module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    class: ['nav', {
      'condensed': _vm.navCondensed
    }],
    attrs: {
      "id": "nav"
    },
    on: {
      "mouseleave": function($event) {
        _vm.taglineVisible = false
      },
      "mouseenter": function($event) {
        _vm.navCondensed = false
      }
    }
  }, [_c('div', {
    staticClass: "nav__mobile-header"
  }, [_c('button', {
    attrs: {
      "id": "navToggleBtn"
    },
    on: {
      "click": function($event) {
        _vm.mobileNavVisible = !_vm.mobileNavVisible
      }
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.mobileNavVisible),
      expression: "!mobileNavVisible"
    }],
    staticClass: "icon icon--menu"
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mobileNavVisible),
      expression: "mobileNavVisible"
    }],
    staticClass: "icon icon--close"
  })]), _vm._v(" "), _c('router-link', {
    staticClass: "home-link",
    attrs: {
      "title": "Home",
      "to": {
        name: 'Intro'
      }
    }
  }, [_c('logo')], 1), _vm._v(" "), _c('div')], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fadeinplace"
    }
  }, [_c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.taglineVisible),
      expression: "!taglineVisible"
    }],
    class: {
      'nav__pages--hidden': !_vm.mobileNavVisible
    }
  }, [_c('div', {
    staticClass: "home-link-outer"
  }, [_c('router-link', {
    staticClass: "home-link",
    attrs: {
      "title": "Home",
      "to": {
        name: 'Intro'
      }
    }
  }, [_c('div', {
    on: {
      "mouseenter": function($event) {
        _vm.taglineVisible = true
      }
    }
  }, [_c('logo')], 1)])], 1), _vm._v(" "), _c('li', [_c('button', {
    class: {
      'submenu-toggle--hidden': _vm.collectionsVisible
    },
    on: {
      "click": function($event) {
        _vm.collectionsVisible = !_vm.collectionsVisible
      }
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Purchase'
      }
    }
  }, [_c('span', [_vm._v("Purchase")])])], 1), _vm._v(" "), _c('ul', {
    class: {
      'submenu--visible': _vm.collectionsVisible
    }
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/collections/bespoke-service"
    }
  }, [_c('span', [_vm._v("Our Bespoke Service")])])], 1), _vm._v(" "), _vm._l((_vm.collections), function(collection) {
    return (collection.data['collection.visible'].value !== 'false' && collection.data['collection.number'].value) ? _c('li', {
      key: collection.id
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'Collection Items',
          params: {
            slug: collection.uid
          }
        }
      }
    }, [_c('span', [_vm._v("Nr " + _vm._s(collection.data['collection.number'].value) + " " + _vm._s(collection.data['collection.title'].value[0].text))])])], 1) : _vm._e()
  })], 2)]), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'Collections'
      }
    }
  }, [_c('span', [_vm._v("Collections")])])], 1), _vm._v(" "), _c('li', {
    staticClass: "is-hidden-mobile"
  }), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": _vm.navLinkRt('site.nav--right-link')
    }
  }, [_c('span', [_vm._v("Information")])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": _vm.navLinkRt('site.nav--contact-page')
    }
  }, [_c('span', [_vm._v("Contact")])])], 1)])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fadeinplace"
    }
  }, [_c('router-link', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.taglineVisible),
      expression: "taglineVisible"
    }],
    staticClass: "tagline century-mono vcenter-content",
    attrs: {
      "to": {
        name: 'Intro'
      }
    }
  }, [_c('span', {
    staticClass: "vcenter"
  }, [_vm._v("\n        Contemporary Products,\n        Traditional Craftsmanship,"), _c('br'), _vm._v(" \n        Designed and Conceived in London\n      ")])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-47d10707"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Nav.vue
// module id = 384
// module chunks = 1